const mixin = {
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
export default mixin